import React, { useContext, useState } from 'react';
import Dialog from '../../../../../components/Dialog/YesNo';
import { store } from './reducer';
import { store as mainStore } from '../../../../../store';
import axios from '../../../../../api/axios';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: theme.spacing(1),
    '& > *': {
      fontSize: 18,
    },
  },
}));

const CashDialog = ({ open, payment, userId, orderId }) => {
  const classes = useStyles();
  const { dispatch, refresh } = useContext(store);
  const { showMessage, showError } = useContext(mainStore);
  const [value, setValue] = useState(null);
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCloseDialog = async (agree) => {
    if (agree) {
      if (!value) {
        showError('یکی از گزینه های پرداخت را انتخاب کنید.');
        return;
      }
      let _transactionType;
      switch (value) {
        case 'toAccount':
          _transactionType = 'واریز به حساب';
          break;
        case 'cardToCard':
          _transactionType = 'کارت به کارت';
          break;
        case 'cash':
          _transactionType = 'نقدی';
          break;
        case 'pos':
          _transactionType = 'دستگاه POS کارت کشید';
          break;
        default:
          _transactionType = '';
          break;
      }
      setLoading(true);
      const { data } = await axios.post(`/api/v1/admin/users/payment`, {
        userId,
        description: `پرداخت بصورت: ${_transactionType} کدرهگیری: ${description}`,
        amount: payment,
        order: orderId,
        transactionType: value,
      });
      if (data.ok) {
        refresh();
        showMessage(data.messages);
      }
    }
    setLoading(false);
    setDescription('');
    setValue(null);
    dispatch({ type: 'CLOSE_PAYMENT_DIALOG' });
  };
  const handleChangeRadio = (e) => {
    const { value } = e.target;
    setValue(value);
  };
  const handleChangeTextField = (e) => {
    const { value } = e.target;
    setDescription(value);
  };

  return (
    <Dialog
      title="پرداخت نقدی کاربر"
      yes="انجام"
      no="صرفنظر"
      open={open}
      onClose={handleCloseDialog}
      loadingButton
      startIcon
      inProgress={loading}
    >
      <div>
        <RadioGroup
          name="transactionType"
          value={value}
          onChange={handleChangeRadio}
          row
          className={classes.root}
        >
          <FormControlLabel
            value="cardToCard"
            control={<Radio />}
            label="کارت به کارت"
          />
          <FormControlLabel
            value="toAccount"
            control={<Radio />}
            label="واریز به حساب"
          />
          <FormControlLabel
            value="pos"
            control={<Radio />}
            label="POS کارت کشید"
          />
          <FormControlLabel value="cash" control={<Radio />} label="نقدی" />
        </RadioGroup>
        <TextField
          value={description}
          variant="outlined"
          size="medium"
          fullWidth
          label="شماره پیگیری"
          onChange={handleChangeTextField}
        />
      </div>
    </Dialog>
  );
};

export default React.memo(CashDialog);
